// extracted by mini-css-extract-plugin
export default {"demographicsWrapper":"Demographics_demographicsWrapper__YVqri","kvpWrapper":"Demographics_kvpWrapper__-WX-r","key":"Demographics_key__FQPFf","value":"Demographics_value__BQN4X"};